import React from "react";
import { Footer } from "antd/lib/layout/layout";
import { AppStoreLogo, PlayStoreLogo, TierhubLogo } from "src/assets/icons";

const ListContact = [
  {
    label: "Contact Us",
    link: "https://tierhub.com.au/contact-us/",
  },
  {
    label: "About",
    link: "https://tierhub.com.au/about/",
  },
  {
    label: "Terms",
    link: "https://web.tierhub.com.au/terms-and-conditions",
  },
  {
    label: "Privacy",
    link: "https://web.tierhub.com.au/privacy-policy",
  },
  // {
  //   label: "Contact",
  //   link: "",
  // },
];
const FooterLayout = () => {
  return (
    <Footer className="footer">
      <div className="footer__contacts">
        <div className="logo">
          <img src={TierhubLogo} alt="" />
        </div>
        <div className="border"></div>
        <div className="contact">
          <ul>
            {ListContact.map((contact: any, index: number) => {
              return (
                <li key={index}>
                  <a target="_blank" href={contact?.link} rel="noreferrer">
                    {contact?.label}
                  </a>
                </li>
              );
            })}
          </ul>
          <p>TIER HUB @ {new Date().getFullYear()}. All rights reserved.</p>
        </div>
      </div>
      <div className="footer__social">
        <a href="#">
          <img src={AppStoreLogo} alt="" />
        </a>
        <a href="#">
          <img src={PlayStoreLogo} alt="" />
        </a>
      </div>
    </Footer>
  );
};

export default FooterLayout;
